var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("el-tabs", {
    model: {
      value: _vm.tab,
      callback: function callback($$v) {
        _vm.tab = $$v;
      },
      expression: "tab"
    }
  }, [_c("el-tab-pane", {
    attrs: {
      label: "基础配置",
      name: "first"
    }
  }, [_c("base-config", {
    attrs: {
      config: _vm.config
    }
  })], 1), _c("el-tab-pane", {
    attrs: {
      label: "表单配置",
      name: "second"
    }
  }, [_vm.tab == "second" ? _c("item-config", {
    attrs: {
      info: _vm.config.formParam
    },
    on: {
      change: _vm.formItemChange
    }
  }) : _vm._e()], 1), _c("el-tab-pane", {
    attrs: {
      label: "API配置",
      name: "third"
    }
  }, [_c("api-config", {
    attrs: {
      config: _vm.config.formApi
    }
  })], 1), _c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };